import MapLocationDetailTileContainer from './MapLocationDetailTileContainer';

export default MapLocationDetailTileContainer;
